import { useContext } from "react";
import {Redirect, useHistory} from "react-router-dom";
import FixelDataContext from "../../context/FixelDataContext";
import Spinner from "../utils/LoadingSpinner";
import Firebase from "../../services/firebase";
import {useAuthState} from "react-firebase-hooks/auth";
import {useCustomer} from "../../provider/customerProvider";

const LoadingPage = (props) => {
    const { fullFixelData } = useContext(FixelDataContext);
    const history = useHistory();
    const [user, loading, error] = useAuthState(Firebase.auth);
    const {customer, loadingCustomer} = useCustomer();

    const redirectOnLoad = () => {
        if (fullFixelData && fullFixelData.state) {
            return "/dashboard";
        }
    };

    if(error){
        return history.push('/errorPage');
    }

    if(loading || loadingCustomer || (user && customer && !props.haveData)){
        return (
            <div className={"mt-2"}>
                <Spinner />
            </div>
        )
    }

    if(!props.haveSegments && user){
        return (
            <Redirect push to={"/introduction"} />
        )
    }

    if(user && customer && props.haveData){
        return(
            <Redirect push to={redirectOnLoad()} />
        )
    }

    return (
        <Redirect push to={'signin'} />
    )

};

export default LoadingPage;
